import React, { useRef, useState } from 'react';
import { ButtonStandard } from '@src/components/Button';
import { COLOR_LIME, ButtonColors } from '@src/types/colors';
import { ButtonIconPosition, ButtonSize } from '@src/types/buttons';
import BoxIcon from '@src/elements/BoxIcon';
import styles from '@src/components/Header/EnquireButton/EnquireButton.module.scss';
import classNames from 'classnames';
import EnquireButtonPopover from './EnquireButtonPopover';
import { handleEnquireButtonScrollToClick } from '@src/utils/scrollToEnquireForm';
import { useViewport } from '@src/hooks/useViewport';
import { useRouter } from 'next/router';

interface EnquireButton {
  scrollToId: string;
  handleCloseMobileMenu?: (event: React.MouseEvent) => void;
  testid: string;
  size?: ButtonSize;
  buttonText?: string;
  color?: ButtonColors;
  iconPosition?: ButtonIconPosition;
  showPopover?: boolean;
}

const EnquireButton: React.FC<EnquireButton> = ({
  scrollToId,
  handleCloseMobileMenu,
  testid,
  size = 'md',
  buttonText = 'Enquire now',
  color = COLOR_LIME,
  iconPosition = 'right',
  showPopover = false
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const buttonRef = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const { width } = useViewport();

  const handleClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleClosePopover = () => {
    setIsPopoverOpen(false);
  };

  return (
    <div>
      {!showPopover ? (
        <div ref={buttonRef}>
          <ButtonStandard
            data-testid={testid}
            color={color}
            aria-label="Enquire"
            size={size}
            onClick={(event) => {
              handleEnquireButtonScrollToClick(
                width,
                router,
                event,
                handleCloseMobileMenu,
                scrollToId
              );
            }}
            className={classNames(styles.enquireButton, {
              [styles.enquireButtonIconLeft]: iconPosition === 'left'
            })}
          >
            {buttonText}
          </ButtonStandard>
        </div>
      ) : (
        <>
          <div ref={buttonRef}>
            <ButtonStandard
              data-testid={testid}
              color={color}
              aria-label="Enquire"
              size={size}
              onClick={handleClick}
              className={classNames(styles.enquireButton, {
                [styles.enquireButtonIconLeft]: iconPosition === 'left'
              })}
            >
              {buttonText}
              <BoxIcon name="edit-alt" size="sm" />
            </ButtonStandard>
          </div>
          <EnquireButtonPopover
            isOpen={isPopoverOpen}
            onClose={handleClosePopover}
            scrollToId={scrollToId}
            handleCloseMobileMenu={handleCloseMobileMenu}
            anchorRef={buttonRef}
          />
        </>
      )}
    </div>
  );
};

export default EnquireButton;
